
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import Bestellung from "@/entities/common/bestellung"
import { Prop } from "vue-property-decorator"
import { LieferungStatus } from "@/entities/common/enums"

@Component
export default class BestellungRowLieferung extends mixins(Calculator) {
  @Prop() bestellung: Bestellung

  formatiereLieferungStatus(bestellung: Bestellung): string {
    switch (bestellung.lieferung.lieferungStatus) {
      case LieferungStatus.ABGESENDET:
        return "Bestellung noch nicht angenommen"
      case LieferungStatus.ANGENOMMEN:
        return "Bestellung angenommen"
      case LieferungStatus.ABGELEHNT:
        return "Bestellung abgelehnt"
      case LieferungStatus.IN_ZUBEREITUNG:
        return "Bestellung in Zubereitung"
      case LieferungStatus.IN_LIEFERUNG:
        return "Bestellung wird ausgeliefert"
      case LieferungStatus.GELIEFERT:
        return "Bestellung ausgeliefert"
    }
  }
}
